module.exports = __webpack_public_path__ + "media/components/home/unlock-vecteezy/img/join-pro-91d993c6887ba08d65c078f0a20ba722.jpg";